import { useOrganisation } from "@/features/select-organisation/api/get-my-organisation";
import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicRoomSystem } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

export const roomSystemQueryKey = (id: string) => ["room-system", id];

const getRoomSystem = async (
  organisationId: string,
  id: string,
): Promise<PublicRoomSystem> => {
  const response = await axiosClient.get(
    `${organisationId}/room-systems/${id}`,
  );
  return response.data;
};

export function useGetRoomSystem(
  { id }: { id: string },
  queryOptions?: UseQueryOptions<PublicRoomSystem, HttpError>,
) {
  const { organisation } = useOrganisation();
  return useQuery({
    queryKey: roomSystemQueryKey(id),
    queryFn: () => getRoomSystem(organisation.id, id),
    ...queryOptions,
  });
}
